module.exports = __webpack_public_path__ + "static/media/edit-profile-dark.fa461c46.svg";